/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Apply_Team_TitleInputs */

const en_template_apply_team_title = /** @type {(inputs: Template_Apply_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply template to team?`)
};

const de_template_apply_team_title = /** @type {(inputs: Template_Apply_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage auf Team anwenden?`)
};

/**
* | output |
* | --- |
* | "Apply template to team?" |
*
* @param {Template_Apply_Team_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const template_apply_team_title = /** @type {((inputs?: Template_Apply_Team_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Apply_Team_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_apply_team_title(inputs)
	return de_template_apply_team_title(inputs)
});